import { render, staticRenderFns } from "./tips-config.vue?vue&type=template&id=fa82f1a4&scoped=true&"
import script from "./tips-config.vue?vue&type=script&lang=js&"
export * from "./tips-config.vue?vue&type=script&lang=js&"
import style0 from "./tips-config.vue?vue&type=style&index=0&id=fa82f1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa82f1a4",
  null
  
)

export default component.exports